import {createAsyncThunk} from '@reduxjs/toolkit';

import {AIS3_SLICE} from 'store/slices/ais-slice/ais-slice-constants';

import {TForecastCommentsCommon, TForecastCommentsCore} from '../model/types';
import {getForecastComments, postForecastComments, putForecastComments} from './api';

export const fetchForecastComments = createAsyncThunk<TForecastCommentsCommon, {requestId: string}>(
    `${AIS3_SLICE}/fetchForecastComments`,
    async (args, {rejectWithValue}) => {
        try {
            const response = await getForecastComments(args);
            const {data} = response;

            return data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const updateForecastComments = createAsyncThunk<string, TForecastCommentsCore>(
    `${AIS3_SLICE}/updateForecastComments`,
    async (args, {rejectWithValue}) => {
        try {
            const response = await putForecastComments(args);
            const {data} = response;

            return data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const sendForecastComments = createAsyncThunk<string, {requestId: string}>(
    `${AIS3_SLICE}/sendForecastComments`,
    async (args, {rejectWithValue}) => {
        try {
            const response = await postForecastComments(args);
            const {data} = response;

            return data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);
